import { render, staticRenderFns } from "./TriviaQuiz.vue?vue&type=template&id=edb360fe"
import script from "./TriviaQuiz.vue?vue&type=script&lang=js"
export * from "./TriviaQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports